import { SignUpFormData } from 'types/auth';

export const initialValues: SignUpFormData = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
};
